/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

  import {
    FILTER_EXPRESSION_OPERATORS,
    SEARCH_ALLVALUE,
  }                                            from 'g3w-constants';
  import ApplicationState                      from 'store/application';
  import GUI                                   from 'services/gui';    
  import { convertQGISDateTimeFormatToMoment } from 'utils/convertQGISDateTimeFormatToMoment';
  import { getDataForSearchInput }             from 'utils/getDataForSearchInput';
  import { getRelationLayerById }              from 'utils/getRelationLayerById';
  import resizeMixin                           from 'mixins/resize';
  import { t, languageIsReady }                from 'g3w-i18n';

  // store all select2 inputs
  const SELECTS = [];

  const __vue_script__ = {

    mixins: [resizeMixin],

    data() {
      return {
       state:      this.$options.service.state,
       autofilter: false, //@since 3.11.0
       allvalue:   SEARCH_ALLVALUE,
       reload:     false,
      }
    },

    computed: {

      layers_url() {
        return ApplicationState.project.getState().layers_url;
      },

      is_staff() {
        return window.initConfig.user.is_staff;
      },

      /**
       * @since 3.11.0 loading inputs data
       * Disabled search form during loading input data
       * @return {*}
       */
      loading() {
        return this.state.forminputs.reduce((bool, i) => bool || i.loading, false);
      },

      /**
       * @TODO make use only of "this.state.search_layers" instead
       */
      search_layers() {
        return [].concat(getRelationLayerById(this.state.search_1n_relationid) || [], this.state.search_layers);
      },

      filterlayers() {
        return ApplicationState.tokens.filtertoken && this.search_layers.filter(l => l.getFilterToken()) || [];
      },

    },

    methods: {
      /**
      * @since 3.11.0
      */
      clearFilters() {
        this.filterlayers.forEach(l => l.getFilterToken() && l.clearSelectionFids());
        //@since v4.0 reset all form values after clear
        this.state.forminputs.forEach(i => {
          if (['selectfield','autocompletefield'].includes(i.type)) {
            i.value = 'in' === i.operator ? [i.values[0].value] : i.values[0].value; //set all or first value
          } else {
            i.value = null;
          }
          this.changeInput(i);
        })
        //@since 4.0.0 close content
        GUI.closeContent();
      },
      resize() {
        SELECTS.forEach(select2 => !ApplicationState.ismobile && select2.select2('close'));
      },

      /**
       * ORIGINAL SOURCE: src/components/SearchPanelLabel.vue@v3.9.3
       */
      getLabelOperator(operator) {
        return `[${FILTER_EXPRESSION_OPERATORS[operator]}]`
      },

      async onFocus(e) {
        if (this.isMobile()) {
          const top = $(e.target).position().top - 10 ;
          await this.$nextTick();
          setTimeout(() => $('.main-sidebar').scrollTop(top), 500);
        }
      },

      /**
       * Sync `this.state.forminputs` with `input.value`
       */
      async changeInput(input) {
        const field  = input.attribute;                                           // current field name
        const deps   = this.state.forminputs.filter(i => field === i.dependance); // inputs that depend on the current one
        const state  = this.state;
        let value    = input.value;

        const is_empty         = v => [].concat(v).find(v => [SEARCH_ALLVALUE, null, undefined].includes(v)) || '' === v.toString().trim(); // whether father input can search on subscribers
        const has_autocomplete = i => 'autocompletefield' === i.type;

        try {
          this.state.searching = true;

          if ('numberfield' === input.type) {
            value = value || 0 === value ? value : null;
          }

          // fallback to default value → `SEARCH_ALLVALUE`
          if (undefined === value) {
            value = SEARCH_ALLVALUE;
          }

          /** @TODO check if it has one reason to trim  */
          if (!['textfield', 'textField'].includes(input.type)) {
            value = Array.isArray(value) ? value.map(v => v.trim()) : value.trim();
          }

          input.value = value;

          // loop and update dependants
          await (Promise.allSettled(deps.map(async d => {

            // cache server data by filter (eg: "zone|eq|A")
            const filter = getDataForSearchInput.field({
              state,
              field,
              fields: [].concat(value).find(v => [SEARCH_ALLVALUE, undefined].includes(v)) //consider in value Array
                ? []
                : ['in' === input.operator //@since 4.0.0 consider in operator
                    ? `${field}|${input.operator}|(${[].concat(value).map( v => encodeURIComponent(v))})`
                    : [].concat(value).map(v => `${field}|${(input.operator || 'eq').toLowerCase()}|${encodeURIComponent(v)}`).join(`|OR,`)
                  ]
            });

            const cached = d.dvalues[filter];

            // In case of in operator
            if ( 'in' === d.operator && ['selectfield', 'autocompletefield'].includes(d.type)) {
              d.value  = [SEARCH_ALLVALUE];
            }

            //In case of no in operator
            if ( 'in' !== d.operator) {
              d.value  =  'selectfield' === d.type ? SEARCH_ALLVALUE : null;
            }

            d.values = Array.from(new Set([                                       // ensure uniques values
              ...(!has_autocomplete(d) && !is_empty(value) ? [d.values[0]] : []), // get first value (ALL_VALUE)
              ...(!has_autocomplete(d) && is_empty(value) ? d._values      : []), // parent has an empty value (eg. ALL_VALUE) → show all original values on subscriber
              ...(cached || []),                                                  // cached
            ]));

            // value is empty → disable dependants inputs
            d.disabled = is_empty(value) ? d.dependance_strict : false;

            // update nested dependencies
            if (this.state.forminputs.find(i => i.dependance === d.attribute)) {
              this.changeInput(d);
            }

            // dependents values are there → no need to perform further server requests
            if (has_autocomplete(d) || is_empty(value) || cached) {
              return;
            }

            state.loading[d.attribute] = true;

            // extract the value of the field to get filter data from the relation layer
            // set undefined because if it has a subscribed input with valuerelations widget

            /** @TODO use `getDataForSearchInput` instead ? */
            try {
              // get data for all searchable layers
              const data = await getDataForSearchInput({ state, layerid: d.alternativeuniquelayer, field: d.attribute, filter });
              // case value map
              if (!d.dependance_strict && 'selectfield' === d.type) {
                d._values.push(...d.values);
              }

              // set key value for select (!valuemap && !valuerelation)
              if (1 === d.values.length) {
                d.values.push(...data);
              }

              // exclude first element (ALL_VALUE)
              d.dvalues[filter] = d.values.slice(1);


            } catch(e) {
              console.warn(e);
            } finally {
              d.disabled                      = false;
              this.state.loading[d.attribute] = false;
            }
          })));
        } catch(e) {
          console.warn(e);
        } finally {
          this.state.searching            = false;
        }
      },

      doSearch(e) {
        e.preventDefault();
        this.$options.service.run();
      },

      /**
       * ORIGINAL SOURCE: src/components/SearchDatetime.vue@v3.9.3
       */
      async initDateTimeField(input) {
        if ('datetimefield' !== input.type) {
          return;
        }

        await this.$nextTick();

        input.options.format.fieldformat   = convertQGISDateTimeFormatToMoment(input.options.format.fieldformat);
        input.options.format.displayformat = convertQGISDateTimeFormatToMoment(input.options.format.displayformat);

        $(this.$refs[`date_${input.id}`]).datetimepicker({
          defaultDate:       null,
          format:            input.options.format.displayformat,
          ignoreReadonly:    true,
          allowInputToggle:  true,
          toolbarPlacement:  'top',
          widgetPositioning: { vertical: 'bottom', horizontal: 'left' },
          showClose:         true,
          locale:            ApplicationState.language || 'en',
        });

        $(this.$refs[`date_${input.id}`]).on("dp.change", () => {
          const newDate = $(`#${input.id}`).val();
          input.value = newDate.trim()
            ? moment(newDate, input.options.format.displayformat).format(input.options.format.fieldformat)
            : null;
          this.changeInput(input);
        });

        if (ApplicationState.ismobile) {
          setTimeout(() => { $('#' + input.id).blur(); });
        }
      },

      /**
       * ORIGINAL SOURCE: src/components/SearchSelect2.vue@v3.9.3
       */
      async initSelect2Field(input) {
        if (!['selectfield', 'autocompletefield'].includes(input.type)) {
          return;
        }

        await this.$nextTick();

        const numdigaut        = input.options.numdigaut;
        const has_autocomplete = 'autocompletefield' === input.type;
        const is_multiple      = 'in' === input.operator; //@since 4.0.0 set multiple select2 only for select box
        const ajax             = has_autocomplete ? {
          delay: 500,
          transport: async (d, ok, ko) => {
            try      {
              ok({
                results: (await getDataForSearchInput({
                  state:    this.state,
                  layerid:  input.alternativeuniquelayer,
                  field:    input.attribute,
                  suggest: `${input.attribute}|${d.data.q}`,
                })).map(d => ({ id: d.value, text: d.key })
                )
              });
            }
            catch(e) { ko(e); }
          }
        } : null;

        const select2 = $(`#${input.id}`).select2({
          ajax,
          width:              '100%',
          dropdownParent:     $('.g3w-search-form:visible'),
          minimumInputLength: has_autocomplete && (numdigaut && !Number.isNaN(1 * numdigaut) && 1 * numdigaut > 0 && 1 * numdigaut || 2) || 0, // get numdigaut and validate it
          allowClear:         has_autocomplete,
          placeholder:        has_autocomplete ? '' : null,
          multiple:           is_multiple, 
          /**
           * @param { Object } params
           * @param params.term the term that is used for searching
           * @param { Object } data
           * @param data.text the text that is displayed for the data object
           */
          matcher: (params, data) => {
            const search = params.term ? params.term.toLowerCase() : params.term;
            if ('' === (search || '').toString().trim())                             { return data }        // no search terms → get all of the data
            if (data.text.toLowerCase().includes(search) && undefined !== data.text) { return { ...data } } // the searched term
            return null;                                                                                    // hide the term
          },
          language: {
            noResults:     () => t("sdk.search.no_results"),
            errorLoading:  () => t("sdk.search.error_loading"),
            searching:     () => t("sdk.search.searching"),
            inputTooShort: d => `${t("sdk.search.autocomplete.inputshort.pre")} ${d.minimum - d.input.length} ${t("sdk.search.autocomplete.inputshort.post")}`,
          },
        });

        SELECTS.push(select2);

        select2.on('select2:select select2:unselecting', e => {

          //Add/Change value

          if ('select2:select' === e.type || has_autocomplete) {
            const value = e.params.data ? `${e.params.data.id}` : SEARCH_ALLVALUE;

            
            if (is_multiple && input.value.find(v => value === v)) {
              input.value = input.value.filter(v => value !== v);
            }

            if (is_multiple && !input.value.find(v => value === v)) {
              //remove alway SEARCH_ALLVALUE value
              input.value = input.value.filter(v => !(value === SEARCH_ALLVALUE) && SEARCH_ALLVALUE !== v);
              input.value.push(value);
            }

            if (!is_multiple) {
              input.value = value;
            }
            
          }

          //remove value  
          if ('select2:unselecting' === e.type && is_multiple) {
            input.value = input.value.filter(v => e.params?.args?.data?.id !== v);
            //If we remove all values, we set the SEARCH_ALLVALUE
            if (0 === input.value.length) {
              input.value = [SEARCH_ALLVALUE];
            }
          }

          this.changeInput(input);


        }
      );

        // trigger select2 change on input value change
        this.$watch(() => input.value, async (value, oldVal) => {
          //Need to convert to an array to consider 'in' operator type
          if ((new Set([].concat(value))).difference((new Set([].concat(oldVal)))) || [].conact(value).find(v => SEARCH_ALLVALUE === v)) {
            select2.val(value).trigger('change');
          }
        });

        // recreate select2 value when language change
        const unwatch = this.$watch(() => ApplicationState.language,  async (lang) => {
          unwatch();
          await languageIsReady(lang);
          this.clearSelect2();
          this.initSelect2Field(input);
        });

        // set initial value
        select2.val(input.value).trigger('change');
      },

      clearSelect2() {
        // remove all select2 DOM events
        SELECTS.forEach(select2 => {
          select2.select2('destroy');
          select2.off();
          select2 = null;
        })
        // reset SELECTS to an empty array
        SELECTS.splice(0);
      },

      /**
       * Reload select2Inputs
        * @return {Promise<void>}
       */
      async reloadSelect2Inputs() {
        //Already reload from another layer
        if (this.reload) { return }

        this.reload = true;
        //wait to be sure that another layer is call to reload
        await this.$nextTick();

        try {
          await this.$options.service.setInputs();
        } catch(e) {
          console.warn(e);
        }

        this.clearSelect2();
        try {
          await Promise.allSettled(this.state.forminputs.map(input => this.initSelect2Field(input)));
        } catch(e) {
          console.warn(e);
        }

        this.reload = false;
      }

    },
    watch: {
      //@since 3.11.0 Set state auto filter to a search result
      autofilter(bool = false) {
        this.state.autofilter.value = Number(bool); //0/1 instead true false
      }
    },

    async created() {
      //Listen change filtertoken on layer
      //Need to listen on each layer instead to watch ApplicationState.tokens.filtertoken changes
      //because when create a new filter with new rules, the filtertoken string doesn't change
      this.search_layers.forEach(l => l.on('filtertokenchange', this.reloadSelect2Inputs));
    },

    async mounted() {
      //@since 3.11.0 Need to add $nextTick()
      // because can happen that .g3w-search-form is not yet visible for select2 dropdownParent:$('.g3w-search-form:visible'),
      await Promise.allSettled([this.$nextTick(), this.state.mounted]);
      for (const input of this.state.forminputs) {
        await this.initSelect2Field(input);
        await this.initDateTimeField(input);
      }
    },

    beforeDestroy() {
      this.search_layers.forEach(l => l.off('filtertokenchange', this.reloadSelect2Inputs));
      this.clearSelect2();
    }

  };

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.searching || _vm.loading || _vm.reload),expression:"state.searching || loading || reload"}],staticClass:"g3w-search-panel form-group"},[_c('bar-loader',{attrs:{"loading":_vm.state.searching || _vm.loading || _vm.reload}}),_vm._v(" "),_c('h4',[_c('b',[_vm._v(_vm._s(_vm.state.title))])]),_vm._v(" "),(_vm.filterlayers.length > 0)?_c('section',{staticStyle:{"display":"flex","justify-content":"space-between"},attrs:{"id":"g3w-search-filter-layers"}},[_c('helpdiv',{attrs:{"message":"sdk.search.help_filter"}}),_vm._v(" "),_c('button',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:left.create",value:('layer_selection_filter.tools.nofilter'),expression:"'layer_selection_filter.tools.nofilter'",arg:"left",modifiers:{"create":true}}],staticClass:"btn skin-border-color",staticStyle:{"background-color":"transparent","margin":"5px 0"},on:{"click":function($event){$event.stopPropagation();return _vm.clearFilters.apply(null, arguments)}}},[_c('i',{staticClass:"skin-color",class:_vm.$fa('clear')})])],1):_vm._e(),_vm._v(" "),_vm._t("tools"),_vm._v(" "),_vm._t("form",function(){return [_c('form',{staticClass:"g3w-search-form"},[_vm._l((_vm.state.forminputs),function(input){return _c('div',{key:input.id,staticClass:"form-group"},[('numberfield' === input.type || ('textfield' === input.type && 'Range' === input.widget_type))?_c('div',{staticClass:"numeric"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"number","min":"0","id":input.id},domProps:{"value":(input.value)},on:{"change":function($event){return _vm.changeInput(input)},"input":[function($event){if($event.target.composing){ return; }_vm.$set(input, "value", $event.target.value)},function($event){return _vm.changeInput(input)}]}})]):(['textfield', 'textField'].includes(input.type))?_c('div',{staticClass:"form-item-search text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(input.value),expression:"input.value"}],staticClass:"form-control",attrs:{"type":"text","id":input.id},domProps:{"value":(input.value)},on:{"focus":_vm.onFocus,"change":function($event){return _vm.changeInput(input)},"input":function($event){if($event.target.composing){ return; }_vm.$set(input, "value", $event.target.value)}}})]):(['selectfield', 'autocompletefield'].includes(input.type))?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || input.loading || input.disabled),expression:"state.loading[input.dependance] || input.loading || input.disabled"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),(input.dependance)?_c('bar-loader',{attrs:{"loading":_vm.state.loading[input.dependance] || input.loading}}):_vm._e(),_vm._v(" "),_c('select',{directives:[{name:"disabled",rawName:"v-disabled",value:(input.disabled || input.loading),expression:"input.disabled || input.loading"}],staticClass:"form-control",attrs:{"name":input.attribute,"id":input.id}},_vm._l((input.values),function(opt){return _c('option',{key:opt.value,domProps:{"value":opt.value}},[(_vm.allvalue === opt.value)?_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.search.all'),expression:"'sdk.search.all'"}]}):_c('span',[_vm._v(_vm._s(opt.key))])])}),0)],1):('datetimefield' === input.type)?_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:(_vm.state.loading[input.dependance] || false),expression:"state.loading[input.dependance] || false"}],staticClass:"text"},[_c('label',{staticClass:"search-label",attrs:{"for":input.id}},[_c('span',[_vm._v(_vm._s(input.label || input.attribute))]),_vm._v(" "),_c('span',{staticClass:"skin-color"},[_vm._v(_vm._s(_vm.getLabelOperator(input.operator)))])]),_vm._v(" "),_c('div',{ref:'date_' + input.id,refInFor:true,staticClass:"input-group date"},[_c('input',{staticClass:"form-control",attrs:{"id":input.id,"type":"text"}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon skin-color"},[_c('span',{class:_vm.$fa(input.options.format.time ? 'time': 'calendar')})])])]):_vm._e(),_vm._v(" "),_c('sub',[_vm._v(_vm._s(input.options.description))]),_vm._v(" "),(_vm.is_staff)?_c('details',{staticStyle:{"cursor":"pointer","user-select":"none","margin-top":".5em"}},[_c('ul',{staticStyle:{"font-size":"80%","padding-left":"15px","font-family":"monospace","white-space":"nowrap","overflow-x":"auto","scrollbar-width":"thin"}},[_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.type))])]),_vm._v(" "),_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v(_vm._s(input.widget_type))]),(input.options.value)?_c('span',[_vm._v(": {"),_c('br'),_vm._v("  key: \""+_vm._s(input.options.key)+"\","),_c('br'),_vm._v("  value: \""+_vm._s(input.options.value)+"\""),_c('br'),_vm._v("}")]):_vm._e()]),_vm._v(" "),(input.options.layer_id)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("layer_id:")]),_vm._v(" \""+_vm._s(input.options.layer_id)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("depends_on:")]),_vm._v(" \""+_vm._s(input.dependance)+"\"")]):_vm._e(),_vm._v(" "),(input.dependance)?_c('li',[_c('b',{staticClass:"skin-color"},[_vm._v("strict:")]),_vm._v(" "+_vm._s(input.dependance_strict))]):_vm._e()])]):_vm._e(),_vm._v(" "),(input.logicop)?_c('div',{staticClass:"search-logicop skin-border-color"},[_c('h4',[_vm._v(_vm._s(input.logicop))])]):_vm._e()])}),_vm._v(" "),_c('div',{directives:[{name:"disabled",rawName:"v-disabled",value:('data' !== _vm.state.return),expression:"'data' !== state.return"}],staticClass:"form-group"},[_c('label',{directives:[{name:"t-tooltip",rawName:"v-t-tooltip:right.create",value:('sdk.search.autofilter_tooltip'),expression:"'sdk.search.autofilter_tooltip'",arg:"right",modifiers:{"create":true}}],staticStyle:{"display":"block"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.autofilter),expression:"autofilter"}],staticStyle:{"margin":"0"},attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.autofilter)?_vm._i(_vm.autofilter,null)>-1:(_vm.autofilter)},on:{"change":function($event){var $$a=_vm.autofilter,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.autofilter=$$a.concat([$$v]))}else{$$i>-1&&(_vm.autofilter=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.autofilter=$$c}}}}),_vm._v(" "),_c('span',{directives:[{name:"t",rawName:"v-t",value:('sdk.search.autofilter'),expression:"'sdk.search.autofilter'"}]}),_vm._v(" "),_c('i',{staticClass:"fa fa-filter fa-pull-right",style:({ opacity: _vm.state.autofilter.value ? 1 : .5 })})])]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('button',{directives:[{name:"t",rawName:"v-t",value:('dosearch'),expression:"'dosearch'"}],staticClass:"sidebar-button-run btn btn-block pull-right",attrs:{"id":"dosearch"},on:{"click":function($event){$event.stopPropagation();return _vm.doSearch.apply(null, arguments)}}})])],2)]}),_vm._v(" "),_vm._t("footer"),_vm._v(" "),(_vm.layers_url)?_c('div',{staticStyle:{"padding-top":"5em"}},[_c('b',[_c('a',{attrs:{"href":_vm.layers_url,"target":"_blank"}},[_vm._v("Edit in admin")])])]):_vm._e()],2)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-12dd074a_0", { source: ".g3w-search-form label[data-v-12dd074a]{color:#fff}.g3w-search-form .search-logicop[data-v-12dd074a]{width:100%;position:relative;display:flex;justify-content:center;margin-bottom:15px;margin-top:30px;border-bottom:1px solid}.g3w-search-form .search-logicop h4[data-v-12dd074a]{font-weight:700;position:absolute;padding:5px;top:-24px;background:var(--bgcolor)}#dosearch[data-v-12dd074a]{color:#fff;font-weight:700;margin-top:15px;background-color:var(--skin-color)}#dosearch[data-v-12dd074a]:hover{color:#fff}.search-label[data-v-12dd074a]{width:100%;display:flex;justify-content:space-between}.search-label .skin-color[data-v-12dd074a]{font-family:monospace}", map: undefined, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = "data-v-12dd074a"
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "SearchPanel.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (true && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__